import Product from '@/ts/Product'

import Form from './includes/Form'

function FansiCollection({ product }: FansiCollectionProps) {
  const availableSizes = product.sizes.filter(({ quantity }) => quantity > 0)

  if (availableSizes.length <= 0) {
    return <p className="text-lg text-black/80">Produkt obecnie niedostępny</p>
  }

  return <Form product={product} />
}

interface FansiCollectionProps {
  product: Product
}

export default FansiCollection
